import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import { getFields } from './Filters';
import {
  defaultValues,
  getInitialAlertIndexFilterValues,
} from '../../shared/selectors/getInitialAlertFilterValues';
import alertQueryToApi from './../utils/alertQueryToApi';
import api from 'server/api';
import downloadCSV from 'utils/downloadCSV';

const mapStateToProps = R.applySpec({
  fields: R.pipe(
    getFields,
    R.innerJoin(
      ({ name }, fieldName) => name === fieldName,
      R.__,
      // This is where you would put a list of filter fields
      // e.g. 'dateRange'
      // It's working, we just don't want to expose it yet. 
      [],
    ),
  ),
  initialValues: getInitialAlertIndexFilterValues,
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (data) => {
    return dispatch(
      downloadCSV(
        api('alert', 'get'),
        alertQueryToApi(data),
        'Alert export',
      ),
    );
  },
});

const AlertCSVExportForm = compose(
  withProps({
    defaultValues,
    event: 'Downloaded Alerts CSV Export',
    submitLabel: 'Download',
    successMessage: 'Your csv is downloading now.',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FormBuilder);

export default AlertCSVExportForm;
